import { xGridDateSort } from "@AMIEWEB/Common";
import { StrictXGridHistoricalHoverView } from "@AMIEWEB/Common/XGrid/cells/HoverViewRenderers/XGridStrictHoverViewContent ";
import { XGridDefaultColumn } from "@AMIEWEB/Common/XGrid/cells/XGridDefaults";
import { XGridChangeHistoryOverflowCell } from "@AMIEWEB/Common/XGrid/cells/XGridChangeHistoryOverflowCell";
import { GridColumns } from "@mui/x-data-grid-pro";

export const changeHistoryColumns = (t): GridColumns => [
    {
      ...XGridDefaultColumn,
      field: 'fieldChanged',
      headerName: t('order.changeHistoryTab.grid.field'),
    },
    {
      ...XGridDefaultColumn,
      field: 'oldValue',
      headerName:  t('order.changeHistoryTab.grid.oldValue'),
      renderCell: XGridChangeHistoryOverflowCell(StrictXGridHistoricalHoverView)(),
      sortable: false,
    },
    {
      ...XGridDefaultColumn,
      field: 'newValue',
      headerName:  t('order.changeHistoryTab.grid.newValue'),
      renderCell: XGridChangeHistoryOverflowCell(StrictXGridHistoricalHoverView)(),
      sortable: false,
    },
    {
      ...XGridDefaultColumn,
      field: 'userName',
      headerName:  t('order.changeHistoryTab.grid.changedBy'),
    },
    {
      ...XGridDefaultColumn,
      field: 'created',
      headerName:  t('order.changeHistoryTab.grid.date'),
      type: 'date',
      sortComparator: xGridDateSort,
    },
    {
      ...XGridDefaultColumn,
      field: 'externalSystem',
      headerName:  t('order.changeHistoryTab.grid.sourceSystem'),
      sortable: false,
    },
  ];